import {
  Combo,
  DiscountPromotion,
  ProductInterface,
  PromotionProductType,
} from "../../types/common.types";
import { ProductType } from "../product";

export const formatPromotionDiscount = (promotion: DiscountPromotion) =>
  promotion.discountType === "percentage"
    ? `${promotion.discountValue}% off`
    : `${promotion.discountValue} off`;

const normalizeProductType = (productType?: string | null) =>
  productType?.toString().trim().toLowerCase();

const normalizeTargetType = (targetType?: string | null) =>
  targetType?.toString().trim().toLowerCase();

export const getProductPromotion = (
  product: ProductInterface,
  productType: ProductType,
  promotions: DiscountPromotion[]
) => {
  const productTypeName: PromotionProductType =
    productType === ProductType.Drink ? "drink" : "food";

  return promotions.find(
    (promotion) =>
      isLivePromotion(promotion) &&
      ((normalizeTargetType(promotion.targetType) === "product" &&
        promotion.targetIds.includes(product.id)) ||
        (normalizeTargetType(promotion.targetType) === "category" &&
          promotion.targetIds.includes(product.categoryId)) ||
        (normalizeTargetType(promotion.targetType) === "product_type" &&
          normalizeProductType(promotion.productType) === productTypeName))
  );
};

export const getComboPromotion = (
  combo: Combo,
  promotions: DiscountPromotion[]
) => {
  return promotions.find(
    (promotion) =>
      isLivePromotion(promotion) &&
      ((normalizeTargetType(promotion.targetType) === "product" &&
        promotion.targetIds.includes(combo.id)) ||
        (normalizeTargetType(promotion.targetType) === "product_type" &&
          normalizeProductType(promotion.productType) === "combo"))
  );
};

const isLivePromotion = (promotion: DiscountPromotion) => {
  if (!promotion.isActive) return false;
  const now = Date.now();
  if (promotion.startsAt && new Date(promotion.startsAt).getTime() > now) {
    return false;
  }
  if (promotion.expiresAt && new Date(promotion.expiresAt).getTime() < now) {
    return false;
  }
  return true;
};
